// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"acd7e2d3","239":"8000f878","455":"75f5a02b"}[chunkId] + ".chunk.js";
};